// ============================================================================
// JARVISTRAVEL - AN INSTALLED APP COVERS THE SCREEN (JAR-2496)
// From the Home Screen the app draws to the screen's edges, and its edges pad
// for the status bar, the notch and the home indicator. A browser tab keeps the
// page as it was until the look on a real phone is decided. WebKit applies a
// changed viewport meta as it does a parsed one, so setting it at boot works.
// ============================================================================

import { isStandalone } from './installPrompt';

/** Adds viewport-fit=cover to the viewport when the app runs installed. */
export function coverScreenWhenInstalled(): void {
  if (!isStandalone()) return;
  const viewport = document.querySelector('meta[name="viewport"]');
  const content = viewport?.getAttribute('content');
  if (!viewport || !content || content.includes('viewport-fit')) return;
  viewport.setAttribute('content', `${content}, viewport-fit=cover`);
}
